module.exports = __webpack_public_path__ + "img/q3-7-active.81e3a7bf.png";